import React, { useEffect, useState } from "react";
import Table from "../ui/Table";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { SortIcon } from "../utils/Icons";
import { bm_date, drawPrice, istl } from "../utils/Utils";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from "dayjs";
import { render } from "@testing-library/react";

export default function SuppliersList(props) {

    const {
        signal = {},
        view = "",
        loading = false,
        setLoading = () => { },
        data = [],
        setData = () => { },
        selected = 0,
        setSelected = () => { },
        filters = { sort: "code"},
        setFilters = () => { },
        route = "",
        align = "auto",
        setAlign = () => { },
        seachResults = {},
        isTitleLink = false,
        filterLocal = () => {},

    } = props;


    const buffer = 20;



    

    const columns = [
        { key: "name", title: <>Name</>, width: 229 },
        { key: "code", title: <>Code</>, width: 65 },
        { key: "currency", title: <>Cy</>, width: 35 },
        { key: "payment_supplier", title: <>Pmts</>, width: 65 },
        { key: "acct", title: <>Acct</>, width: 65 },
        { key: "available_on_hand", title: <>Total Marked</>, width: 110, render : () => { return "No access..."} },
        { key: "available_on_hand", title: <>2025</>, width: 75, render : () => { return "2025"} },
        { key: "available_on_hand", title: <>2024</>, width: 75 },
        { key: "available_on_hand", title: <>Last</>, width: 100, render : () => { return "Aug20-25"} },

    ]


    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.code === selected?.code) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.code === selected?.code) - _rows;


        if (prevIndex < 2) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const fetchNext = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("supplier.getNext", { ...filters, "limit": 20, "code": data[data.length - 1]?.code }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const fetchPrev = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("supplier.getPrevious", { ...filters, "limit": 20, "code": data[0]?.code }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const fetch = () => {
        if (loading) { return }
        setLoading(true);
        let _filters = { ...filters };
        if (selected?.code) {
            _filters.code = selected.code;
        }
        // Don't search empty titlelink code (prefix with no-stock)
        if (_filters.code && _filters.code.includes("no-stock")) {
            delete _filters.code;
        }
        pubCall("supplier.getInitial", {...filters, limit : 45}, (_s, _r) => {
            if (_s) {

                if (_r.rows_previous.length > 0) {
                    setAlign("start");
                }
                setData(_r.rows_previous.concat(_r.rows_next));

                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(fetch, [filters]);


   
    
    return (
        <>

        <VirtualTable
            onWheel={(e) => (e.deltaY > 0) ? next() : prev()}
            onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
            next={next}
            prev={prev}
            align={align}

            row_key={"code"}
            current={selected}
            data={data}
            columns={columns}
            width={918}
            loading={loading}
            offset={380}
            route={route}
        />
        </>
    )
}